module.exports = __webpack_public_path__ + "img/icon2.ffe93155.png";